// extracted by mini-css-extract-plugin
export default {"wrapper":"RentImageList_wrapper__Elfzm","bgEmpty":"RentImageList_bgEmpty__omNAC"};